/**
 * Config global del frontend.
 *
 * Valores que pueden ajustarse por entorno (Vite env vars con prefix VITE_).
 * Lo público (URLs, flags) va aquí; secretos NUNCA.
 */

/** Link público de Mercado Pago para recibir donaciones.
 *  Default: link real configurado para PaniniNilabs. Override por env si se quiere
 *  cambiar a uno de pruebas (sandbox) en local. */
export const DONATION_URL: string = (
  import.meta.env.VITE_MP_DONATION_URL || "https://link.mercadopago.com.co/panininilabs"
).trim();

export const HAS_DONATIONS: boolean = Boolean(DONATION_URL);

/** Transferencia directa por llave Bre-B (interoperable: Nequi, Daviplata, etc).
 *  Usamos llave en lugar del celular para no exponer el número personal del
 *  fundador (mitiga SIM swap, phishing por SMS, intentos de hackeo). */
export const DONATION_KEY_HANDLE: string = "@nilton481";
export const DONATION_KEY_NAME: string = "Nilton Alfonso · Nilabs";

/** Montos sugeridos en COP. El usuario puede elegir cualquier monto en MP. */
export const SUGGESTED_AMOUNTS: number[] = [3000, 5000, 10000, 30000];
